import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/scss/style.scss";
// 引入 jQuerynp
import $ from "jquery";
// 将 jQuery 挂载到 Vue 的原型上，这样在组件中可以通过 this.$ 来使用
Vue.prototype.$ = $;
Vue.config.productionTip = false;
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
